// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1hms8stv{text-decoration-line:underline}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}\n._kqswh2mm{position:relative}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
